var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.59933C10.1742 9.59933 9.50482 10.2265 9.50482 11.0001C9.50482 11.7737 10.1742 12.4009 11 12.4009C11.8257 12.4009 12.4951 11.7737 12.4951 11.0001C12.4951 10.2265 11.8257 9.59933 11 9.59933Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3937 9.49526C18.2021 10.3705 18.2021 11.6296 17.3937 12.5049C16.0338 13.9773 13.6782 16.0001 11 16.0001C8.32183 16.0001 5.9662 13.9773 4.60628 12.5049C3.79791 11.6296 3.79791 10.3705 4.60628 9.49526C5.9662 8.02286 8.32183 6.00006 11 6.00006C13.6782 6.00006 16.0338 8.02286 17.3937 9.49526ZM7.92068 11.0001C7.92068 12.5934 9.29931 13.885 11 13.885C12.7006 13.885 14.0792 12.5934 14.0792 11.0001C14.0792 9.4068 12.7006 8.11517 11 8.11517C9.29931 8.11517 7.92068 9.4068 7.92068 11.0001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.25C5.61522 1.25 1.25 5.61522 1.25 11C1.25 16.3848 5.61522 20.75 11 20.75C13.4221 20.75 15.639 19.866 17.3436 18.4043L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.4043 17.3436C19.866 15.639 20.75 13.4221 20.75 11C20.75 5.61522 16.3848 1.25 11 1.25ZM2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 13.2784 18.3274 15.3399 16.8336 16.8336C15.3399 18.3274 13.2784 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeTest);
export default __webpack_public_path__ + "static/media/eye-test.2faca667c02ec6c90176b5b77508ca0d.svg";
export { ForwardRef as ReactComponent };